import React, { Component } from 'react'
import { BrowserRouter as Router } from 'react-router-dom';
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline, Link
} from "mdbreact";
import {  MDBContainer, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip } from 'antd';
import { URL } from '../api';
import logo from '../Pages/img/logokpru.png'


export default class Header extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      nameuser: '',
      admin_type: '',
      Username: '',
      collapse: false,
      isWideEnough: false,

      
    };
    this.onClick = this.onClick.bind(this);
    this.pdf = this.pdf.bind(this);
    this.pdf2 = this.pdf2.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  pdf() {
    
     // window.location.href = 'https://e-student.kpru.ac.th/webregisfinish/download/Manualregister.pdf '
      window.open('https://e-student.kpru.ac.th/webregisfinish/download/Manualregister.pdf ', '_blank');

    }
    pdf2() {
    
      // window.location.href = 'https://e-student.kpru.ac.th/webregisfinish/download/Manualregister.pdf '
       window.open('https://std.kpru.ac.th/kpnnews/prnews/file/schedule-graduate-kpru-2565.pdf ', '_blank');
 
     }

  
    

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }



    componentDidMount() {
      //  const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('name') !== "") {
          this.setState({ nameuser: localStorage.getItem('name') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
    
            this.setState({ admin_type: 'public' })

        }

         // this.setState({ nameuser: localStorage.getItem('nameuser') })
         // this.setState({ admin_type: localStorage.getItem('admin_type') })
      }


      logout() {
      //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
    
        setTimeout(() => {
          window.location.href = 'https://e-student.kpru.ac.th/vaccinekpru'
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }



    render() {



        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Check"><MDBIcon icon="file-alt" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/Stuall"><MDBIcon far icon="user-circle" /> นักศึกษา</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Personnelpage"><MDBIcon icon="user-circle" /> บุคลากร</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Report"><MDBIcon far icon="address-card" /> รายงานข้อมูลสถานะ</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Learn"><MDBIcon far icon="chart-bar" />ตารางเรียน</MDBNavLink>
            </MDBNavItem> */}
            {/* <MDBNavItem >
                 <MDBNavLink to="/Classroom"><MDBIcon far icon="chart-bar" />จัดการห้องเรียน</MDBNavLink>
            </MDBNavItem> */}
           


             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

    


        let publics
        publics = (
          <>
            <MDBNavItem  >
              <MDBNavLink to="/">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2">ประกาศ</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBDropdownItem href="https://std.kpru.ac.th/kpnnews/prnews/file/graduate-kpru-2565.pdf"  target="_blank">ประกาศการรายงานตัวของบัณฑิต</MDBDropdownItem>
                
                 
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            <MDBNavItem onClick={this.pdf} >
             <MDBNavLink to=""> คู่มือการลงทะเบียน</MDBNavLink>
            
            </MDBNavItem>
            <MDBNavItem onClick={this.pdf2} >
             <MDBNavLink to=""> กำหนดการ</MDBNavLink>
            
            </MDBNavItem> */}


            {/* <MDBNavItem  >
              <MDBNavLink to="/">   ส่งผลการวิ่ง </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   ตรวจสอบผลการวิ่ง </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   กติกาและข้อมูล </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   แอปพลิเคชัน </MDBNavLink>
            </MDBNavItem> */}
           
            {/* <MDBNavItem  >
              <MDBNavLink to="/main/LoginPages">  เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem> */}
          
          </>
        )

        const name = this.state.nameuser;

     //   console.log(this.state.collapse)
        return (
            <>
                

                <div>
        <header>
          <Router>
            <MDBNavbar color="warning-color-dark " fixed="top" dark expand="md" scrolling transparent>
              <MDBNavbarBrand href="/">
             
              <strong> <img src={logo} className="rounded mx-auto  " alt="aligment"  width='30px'  /> KPRU INFO</strong>
              </MDBNavbarBrand>
              {!this.state.isWideEnough && <MDBNavbarToggler onClick={this.onClick} />}
              <MDBCollapse isOpen={this.state.collapse} navbar>
                {/* <MDBNavbarNav left>
                  <MDBNavItem >
                    <MDBNavLink   to="#">Home</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="#">Link</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="#">Profile</MDBNavLink>
                  </MDBNavItem>
                </MDBNavbarNav> */}
              </MDBCollapse>
            </MDBNavbar>
          </Router>

        
        </header>

      
      </div>
                

            </>
        )
    }
}

